import { render, staticRenderFns } from "./New.vue?vue&type=template&id=1e079e70&scoped=true&"
var script = {}
import style0 from "./New.vue?vue&type=style&index=0&id=1e079e70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e079e70",
  null
  
)

export default component.exports